module.exports = __webpack_public_path__ + "static/media/Group 1000002795.3ee0bba9.svg";